import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress } from '@mui/material';
import "./FormDialog.css";
import "./SubtaskSelectionDialog.css";
import Button from "../Button/Button";
import close from '../../assets/icons/close.svg';
import { Tooltip } from '@mui/material';
import { getSubtasksByProjectName } from '../../services/homeService';

export default function SubtaskSelectionDialog(props) {
  const { open, handleClose, projectName, projectId, onSubtaskSelect, clientId } = props;
  const [subtasks, setSubtasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if (open && projectName) {
      fetchSubtasks();
    }
  }, [open, projectName]);

  const fetchSubtasks = async () => {
    try {
      setLoading(true);
      const response = await getSubtasksByProjectName(projectName);
      
      // Filter out completed subtasks (those with status "Closed" or "Done")
      const activeSubtasks = (response || []).filter(subtask => 
        subtask.status !== "Closed" && subtask.status !== "Done"
      );
      
      setSubtasks(activeSubtasks);
    } catch (error) {
      console.error("Error fetching subtasks:", error);
      setSubtasks([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSubtaskSelect = (subtask) => {
    if (onSubtaskSelect) {
      onSubtaskSelect(subtask);
    }
    handleClose();
  };

  const filteredSubtasks = subtasks.filter(subtask => 
    subtask.key.toLowerCase().includes(searchValue.toLowerCase()) || 
    (subtask.summary && subtask.summary.toLowerCase().includes(searchValue.toLowerCase()))
  );

  return (
    <div>
      <Dialog 
        className='custom-dialog subtask-selection-dialog' 
        open={open} 
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle className="title-dialog">
          Select a Subtask
          <Tooltip title='Close' arrow placement='bottom'>
            <img
              tabIndex={0}
              src={close}
              onClick={handleClose}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  handleClose();
                }
              }}
              alt='/'
              style={{ cursor: "pointer" }}
            />
          </Tooltip>
        </DialogTitle>
        <DialogContent className='content-dialog'>
          <div className="subtask-search">
            <input
              type="text"
              placeholder="Search subtasks..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className="subtask-search-input"
            />
          </div>
          
          {loading ? (
            <div className="subtask-loading">
              <CircularProgress />
            </div>
          ) : subtasks.length === 0 ? (
            <div className="no-subtasks-message">
              No subtasks found for this project
            </div>
          ) : (
            <div className="subtask-list">
              {filteredSubtasks.map((subtask) => (
                <div 
                  key={subtask.id} 
                  className="subtask-item"
                  onClick={() => handleSubtaskSelect(subtask)}
                >
                  <div className="subtask-key">{subtask.key}</div>
                  <div className="subtask-summary">{subtask.summary}</div>
                  <div className="subtask-status">
                    <span className={`status-indicator status-${subtask.status?.replace(/\s+/g, '-').toLowerCase() || 'start'}`}></span>
                    <span className="status-text">{subtask.status || 'Start'}</span>
                  </div>
                </div>
              ))}
              
              {filteredSubtasks.length === 0 && (
                <div className="no-results">No matching subtasks found</div>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className="cancel button-popup"
            text="Cancel"
            onClick={handleClose}
            heading="Cancel"
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}
